import React, { useCallback, useContext, useEffect, useState } from 'react'
import { RateAndAccuracyLabel, WrapAccordion } from './Style'
import { FactoredPercentAccuracyTooltip, ratingHooks } from '.'
import { useTheme } from 'styles'
import { useSelector } from 'react-redux'
import { isEmpty, keyBy, set } from 'lodash'
import { AccordionDetails, AccordionSummary, Button, Divider, SvgIcon } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'
import { IconButtons } from 'components/Form'
import { ReportContext } from './ReportContext'
import { Space, Top, XSSpaceBetween } from 'styles/GlobalStyle'
import { ReportStyles } from './Style'
import { useQueryClient } from '@tanstack/react-query'
import qc from 'keys/queryClient'

const RateAndAccuracy = (props) => {
    const { setExpandItem, expandItem, expand, setExpand, viewGraph, setViewGraph } = useContext(ReportContext)
    const { rating } = useSelector(state => state.rating)
    const { Layout, Gutters } = useTheme()
    const queryClient = useQueryClient()
    const scoreRating = queryClient.getQueryData([qc.ratings])

    const [previousStats, setPreviousStats] = useState(null);

    const rateAndAccuracyItems = ratingHooks.useRateAndAccuracyItems()
    const viewGraphBtns = ratingHooks.useViewGraphBtns()
    const viewGraphKeys = keyBy(viewGraphBtns, "key")
    const rateAndAccuracyKeys = keyBy(rateAndAccuracyItems, "type")

    const updateExpandItem = useCallback((index, item) => {
        let nExpand = [...expand]
        nExpand[index] = !expand[index]
        setExpand(nExpand)
        if (!expand[index])
            setExpandItem(index)

        if (!viewGraph[item]) {
            setViewGraph({ ...viewGraph, [item]: viewGraphBtns[0].key })
        }
    }, [viewGraph, expand])

    const updateViewGraph = useCallback((e, key, val, item, index) => {
        if (!expand[index])
            updateExpandItem(index)

        setViewGraph({ ...viewGraph, [key]: val })
        if (item.stats) {
            setPreviousStats(item.stats);
        }
        // rateAndAccuracyKeys[key]?.refetch(viewGraphKeys[val]?.params)
    }, [viewGraph, expand])

    return (
        <ReportStyles>
            {rateAndAccuracyItems.map((item, index) => {

                const viewGraphItem = viewGraphKeys[viewGraph[item.type]]
                return (
                    <React.Fragment>
                        <WrapAccordion expanded={expand?.[index]}>
                            <AccordionSummary
                                sx={{
                                    ...Layout.fullHeight,
                                    pointerEvents: !item.expand && "none"
                                }}
                                expandIcon={
                                    item.expand &&
                                    <ExpandMore
                                        onClick={() => updateExpandItem(index, item.type)}
                                    />
                                }
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <div style={{ ...Layout.rowHCenter, ...Layout.justifyContentBetween, ...Layout.fullWidth }}>
                                    <div className='wrap-report-item'>
                                        {item.label && <RateAndAccuracyLabel>{item.label}</RateAndAccuracyLabel>}
                                        {item.tooltip &&
                                            <Top top={-7}>
                                                <item.tooltip />
                                            </Top>}
                                        <XSSpaceBetween />
                                        {isEmpty(rating) ||
                                            <div className='tab-title'>
                                                <item.text />
                                            </div>}
                                    </div>
                                    <div style={{ ...Layout.rowHCenter, ...Layout.mcGap, ...Gutters.tinyLPadding }}>
                                        {item.showGraphBtns &&
                                            <React.Fragment>
                                                <IconButtons
                                                    key={item.type}
                                                    defaultSelectedIndex={0}
                                                    selected={viewGraph[item.type]}
                                                    setSelected={(e, val) => {
                                                        updateViewGraph(e, item.type, val, item, index)
                                                    }}
                                                    btns={viewGraphBtns}
                                                />
                                            </React.Fragment>}
                                    </div>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                {viewGraphItem?.component &&
                                    <viewGraphItem.component
                                        scoreRating={scoreRating}
                                        disabled={!item.stats}
                                        stats={item.stats || previousStats}
                                        graph={item.graph}
                                        percent={item.percent}
                                        viewItemCount={viewGraphItem.showChildren}
                                        fullWidth
                                        hideBarText
                                        viewTestTaker //needs for height bar item
                                    // type={item.type}
                                    // showChildren={viewGraph[item.type]} //show all the
                                    />}
                            </AccordionDetails>
                        </WrapAccordion>
                    </React.Fragment>
                )
            }
            )}
        </ReportStyles>
    )
}

export default RateAndAccuracy